import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
let PqlRuleManagementApi = class PqlRuleManagementApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getPQLRuleDetail = (ruleId) => {
            const url = format(this.urls.getPQLRuleDetail, {
                ruleId,
            });
            return this.http.get({
                url: url,
            });
        };
        this.addPQLRule = (params) => {
            return this.http.post({
                url: this.urls.addPQLRule,
                data: { ...params },
            });
        };
        this.editPQLRule = (params) => {
            return this.http.put({
                url: this.urls.addPQLRule,
                data: { ...params },
            });
        };
        this.editStatus = (params) => {
            const url = format(this.urls.editPQLRuleStatus, {
                ruleId: params.id,
            });
            return this.http.put({
                url: url,
                data: {
                    status: params.status,
                },
            });
        };
        this.getPQLRuleManagementList = (params) => {
            const { sEcho, iDisplayLength, iDisplayStart, product_line_id } = params;
            return this.http.get({
                url: this.urls.getPqlRuleManagementList,
                params: {
                    sEcho,
                    iDisplayLength,
                    iDisplayStart,
                    product_line_id,
                },
            });
        };
        this.checkPQLRuleName = (params) => {
            return this.http.get({
                url: this.urls.checkPQLRuleName,
                params,
            });
        };
        this.getPQLRuleDataAnalysisList = (params) => {
            const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
            return this.http.post({
                url: this.urls.getPqLRuleDataAnalysisList,
                params: {
                    sEcho,
                    iDisplayLength,
                    iDisplayStart,
                },
                data: {
                    ...otherParams,
                },
            });
        };
        this.getPQLRuleFilterFieldProperty = (id, time_effective_type) => {
            return this.http.get({
                url: this.urls.getPQLRuleFilterFieldProperty,
                params: {
                    product_line_id: id,
                    time_effective_type,
                },
            });
        };
        this.preRunRule = (params) => {
            return this.http.post({
                url: this.urls.preRunRule,
                data: { ...params },
            });
        };
        this.deletePQLRule = (ruleId) => {
            const url = format(this.urls.deletePQLRule, {
                ruleId,
            });
            return this.http.delete({
                url: url,
            });
        };
    }
};
PqlRuleManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.PqlRuleManagementUrls)),
    __metadata("design:paramtypes", [Object, Object])
], PqlRuleManagementApi);
export { PqlRuleManagementApi };
